module.exports = __webpack_public_path__ + "static/Logo_Signet-d5357567f83edabe722e94f4fc4f0b8d.svg";